module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Mono-Bold-69edfec2b4a591522601850a4c8c0ee9.woff";